export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
export function objectToString(obj) {
  var separator = arguments[1] || '&';
  var result = '';
  for (var p in obj) {
    if (typeof (obj[p]) == 'function') {
      continue;//跳过
    } else {
      result += p + '=' + obj[p] + separator;
    }
  }
  result = result.substring(0, result.length - 1);
  return result;
};
export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}
//时间戳转为时间格式
export function getTimeStr(time, format) {
  if(!time) {
    return "";
  }
  if (time.toString().length == 10) {
    var date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  } else {
    var date = new Date(time);
  }
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  switch (format) {
    case 'YMDhm':
      return `${Y}-${M}-${D} ${h}:${m}`;
    case 'YMD':
      return `${Y}-${M}-${D}`;
    case 'hms':
      return `${h}:${m}:${s}`;
    default:
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  }
}

export function checkPhone(rule, value, callback) {
  if(!value){
    callback(new Error('请输入手机号码！'));
  }else{
  if (!(/^1[3456789]\d{9}$/.test(value))) {
    callback(new Error('请输入正确的手机号码'));
  } else {
    callback();
  }
  }
}

export function checkPrice(rule, value, callback) {
  if(!value){
    callback(new Error('请输入金额！'));
  }else{
    if (!(/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(value))) {
      callback(new Error('请输入正确的金额'));
    } else if(value<=0){
      callback(new Error('请输入正确的金额'));
    } else if(value>100000){
      callback(new Error('最多为5位数+2位小数'));
    }else{
      callback();
    }
  }
}
export function checkNumber(rule, value, callback) {

    if (!(/(^[1-9]\d*$)/.test(value))) {
      callback(new Error('请输入正整数'));
    } else{
      callback();
    }
}


export function accAdd(arg1, arg2) {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
}



// WEBPACK FOOTER //
// ./src/utils/index.js